import axios from "axios";

// Define this in .env.development and .env.production as REACT_APP_API_ROOT
// Example values must include trailing slash: http://localhost:8000/api/
const API_ROOT = process.env.REACT_APP_API_ROOT;

if (!API_ROOT) {
  throw new Error(
    "Missing REACT_APP_API_ROOT. Add it to .env.development / .env.production (include trailing slash)."
  );
}

export const coreApi = axios.create({
  baseURL: `${API_ROOT}core/`,
});

export const chemistryApi = axios.create({
  baseURL: `${API_ROOT}chemistry/`,
});
